import { Owner } from "../types/owner";
import { axiosService } from "./axios.service";

export class ContactUsService {
  static async getContactUsInfo(): Promise<Owner | undefined> {
    try {
      const response: Owner = await axiosService.get(`/contact/get-user-agent`);

      return response;
    } catch (error) {
      console.error(error);
    }
  }
}
